import React from "react";
import styled from "styled-components";
import { Scale } from 'react-scaling';

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background: ${props => (props.background ? "#683d8c" : "683d8c")};
  z-index: 2;
  opacity: 0.5;
`;

const Spinner = () => {
  return (
    <svg
      version="1.1"
      id="L2"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enableBackground="new 0 0 100 100"
      xmlSpace="preserve"
      style={{ maxWidth: "150px" }}
    >
      <circle
        fill="none"
        stroke="#fff"
        strokeWidth="4"
        strokeMiterlimit="10"
        cx="50"
        cy="50"
        r="48"
      />
      <line
        fill="none"
        strokeLinecap="round"
        stroke="#fff"
        strokeWidth="4"
        strokeMiterlimit="10"
        x1="50"
        y1="50"
        x2="85"
        y2="50.5"
      >
        <animateTransform
          attributeName="transform"
          dur="2s"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"
        />
      </line>
      <line
        fill="none"
        strokeLinecap="round"
        stroke="#fff"
        strokeWidth="4"
        strokeMiterlimit="10"
        x1="50"
        y1="50"
        x2="49.5"
        y2="74"
      >
        <animateTransform
          attributeName="transform"
          dur="15s"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"
        />
      </line>
    </svg>
  );
};

const Loading = ({ message, background }) => {
  return (

    <LoadingContainer background={background}>
      <Scale scaleTo={1720}>
        <Spinner />
        <h1 style={{ color: "#ffffff" }}>{message}</h1>
      </Scale>
    </LoadingContainer >

  );
};

export { Loading };
